const API_URL = "/api/jobs";

// ==========================================
// GET TOKEN / AUTH HEADERS
// ==========================================

const getAuthHeaders = () => {

  const token = localStorage.getItem("token");

  return {
    "Content-Type": "application/json",

    ...(token && {
      Authorization: `Bearer ${token}`,
    }),
  };
};


// ==========================================
// CREATE JOB
// ==========================================

export const createJob = async (jobData) => {

  const response = await fetch(API_URL, {
    method: "POST",

    headers: getAuthHeaders(),

    body: JSON.stringify(jobData),
  });


  const responseText =
    await response.text();


  let data = null;


  try {

    data = responseText
      ? JSON.parse(responseText)
      : null;

  } catch {

    data = responseText;

  }


  console.log(
    "CREATE JOB STATUS:",
    response.status
  );

  console.log(
    "CREATE JOB RESPONSE:",
    data
  );


  if (!response.ok) {

    let message =
      "Failed to create job.";


    if (
      typeof data === "object" &&
      data !== null
    ) {

      message =
        data.message ||
        data.error ||
        message;

    } else if (
      typeof data === "string" &&
      data.trim()
    ) {

      message = data;

    }


    throw new Error(
      `${message} (HTTP ${response.status})`
    );
  }


  return data;
};


// ==========================================
// GET ALL JOBS
// ==========================================

export const getAllJobs = async () => {

  const response = await fetch(
    API_URL,
    {
      method: "GET",
      headers: getAuthHeaders(),
    }
  );


  const responseText =
    await response.text();


  let data = null;


  try {

    data = responseText
      ? JSON.parse(responseText)
      : null;

  } catch {

    data = responseText;

  }


  if (!response.ok) {

    let message =
      "Failed to fetch jobs.";


    if (
      typeof data === "object" &&
      data !== null
    ) {

      message =
        data.message ||
        data.error ||
        message;

    } else if (
      typeof data === "string" &&
      data.trim()
    ) {

      message = data;

    }


    throw new Error(
      `${message} (HTTP ${response.status})`
    );
  }


  return data;
};


// ==========================================
// GET JOB BY ID
// ==========================================

export const getJobById = async (jobId) => {

  const response = await fetch(
    `${API_URL}/${jobId}`,
    {
      method: "GET",
      headers: getAuthHeaders(),
    }
  );


  const responseText =
    await response.text();


  let data = null;


  try {

    data = responseText
      ? JSON.parse(responseText)
      : null;

  } catch {

    data = responseText;

  }


  if (!response.ok) {

    let message =
      "Failed to fetch job.";


    if (
      typeof data === "object" &&
      data !== null
    ) {

      message =
        data.message ||
        data.error ||
        message;

    } else if (
      typeof data === "string" &&
      data.trim()
    ) {

      message = data;

    }


    throw new Error(
      `${message} (HTTP ${response.status})`
    );
  }


  return data;
};


// ==========================================
// GET JOBS BY USER
// ==========================================

export const getJobsByUser = async (userId) => {

  const response = await fetch(
    `${API_URL}/partner/${userId}`,
    {
      method: "GET",
      headers: getAuthHeaders(),
    }
  );


  const responseText =
    await response.text();


  let data = null;


  try {

    data = responseText
      ? JSON.parse(responseText)
      : null;

  } catch {

    data = responseText;

  }


  if (!response.ok) {

    let message =
      "Failed to fetch user jobs.";


    if (
      typeof data === "object" &&
      data !== null
    ) {

      message =
        data.message ||
        data.error ||
        message;

    } else if (
      typeof data === "string" &&
      data.trim()
    ) {

      message = data;

    }


    throw new Error(
      `${message} (HTTP ${response.status})`
    );
  }


  return data;
};


// ==========================================
// UPDATE JOB
// ==========================================

export const updateJob = async (
  jobId,
  jobData
) => {

  const response = await fetch(
    `${API_URL}/${jobId}`,
    {
      method: "PUT",

      headers: getAuthHeaders(),

      body: JSON.stringify(jobData),
    }
  );


  const responseText =
    await response.text();


  let data = null;


  try {

    data = responseText
      ? JSON.parse(responseText)
      : null;

  } catch {

    data = responseText;

  }


  if (!response.ok) {

    let message =
      "Failed to update job.";


    if (
      typeof data === "object" &&
      data !== null
    ) {

      message =
        data.message ||
        data.error ||
        message;

    } else if (
      typeof data === "string" &&
      data.trim()
    ) {

      message = data;

    }


    throw new Error(
      `${message} (HTTP ${response.status})`
    );
  }


  return data;
};


// ==========================================
// UPDATE JOB STATUS
// ==========================================
// API:
// PATCH /api/jobs/{jobId}/status
// ==========================================
export const updateJobStatus = async (
  jobId,
  status
) => {

  if (!jobId) {
    throw new Error("Job ID is required.");
  }

  if (!status) {
    throw new Error("Job status is required.");
  }

  console.log(
    "UPDATE JOB STATUS REQUEST:",
    {
      jobId,
      status,
    }
  );


  const response = await fetch(
    `${API_URL}/${jobId}/status`,
    {
      method: "PATCH",

      headers: getAuthHeaders(),

      // IMPORTANT:
      // Backend JobController is expecting
      // JobRequestDTO in @RequestBody
      body: JSON.stringify({
        status: status,
      }),
    }
  );


  const responseText =
    await response.text();


  let data = null;


  try {

    data = responseText
      ? JSON.parse(responseText)
      : null;

  } catch {

    data = responseText;

  }


  console.log(
    "UPDATE JOB STATUS HTTP:",
    response.status
  );

  console.log(
    "UPDATE JOB STATUS RESPONSE:",
    data
  );


  if (!response.ok) {

    let message =
      "Failed to update job status.";

    if (
      typeof data === "object" &&
      data !== null
    ) {

      message =
        data.message ||
        data.error ||
        message;

    } else if (
      typeof data === "string" &&
      data.trim()
    ) {

      message = data;

    }


    throw new Error(
      `${message} (HTTP ${response.status})`
    );
  }


  return data;
};

// ==========================================
// DELETE JOB
// ==========================================

export const deleteJob = async (jobId) => {

  const response = await fetch(
    `${API_URL}/${jobId}`,
    {
      method: "DELETE",

      headers: getAuthHeaders(),
    }
  );


  const responseText =
    await response.text();


  if (!response.ok) {

    let data = null;


    try {

      data = responseText
        ? JSON.parse(responseText)
        : null;

    } catch {

      data = responseText;

    }


    let message =
      "Failed to delete job.";


    if (
      typeof data === "object" &&
      data !== null
    ) {

      message =
        data.message ||
        data.error ||
        message;

    } else if (
      typeof data === "string" &&
      data.trim()
    ) {

      message = data;

    }


    throw new Error(
      `${message} (HTTP ${response.status})`
    );
  }


  return true;
};


// ==========================================
// DEFAULT EXPORT
// ==========================================

export default {

  createJob,

  getAllJobs,

  getJobById,

  getJobsByUser,

  updateJob,

  updateJobStatus,

  deleteJob,

};